import { Fragment } from "react";
import { collectAssistantCitations } from "@cmmd-forge/shared/assistantCitations";
import { AssistantCitationChip } from "./AssistantCitationChip";

/** Keep user prose literal while rendering validated quotation references. */
export function UserMessageText({ text }: { readonly text: string }) {
  const citations = collectAssistantCitations(text);
  if (citations.length === 0) return text;
  return (
    <>
      {citations.map((entry, index) => (
        <Fragment key={entry.start}>
          {text.slice(index === 0 ? 0 : citations[index - 1]!.end, entry.start)}
          <AssistantCitationChip citation={entry.citation} />
        </Fragment>
      ))}
      {text.slice(citations[citations.length - 1]!.end)}
    </>
  );
}
